<template>
  <v-layout row pa-3>
    <v-fab-transition>
      <v-btn
        v-if="isAdmin"
        color="pink"
        dark
        fixed
        bottom
        right
        fab
        @click="createItem"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-flex xs12>
      <v-alert :value="noData" dismissible color="error" icon="warning" outlined
        >We can't find a business. Please use business id (bid), phone number
        (national or international) or business code.</v-alert
      >
      <v-card>
        <v-toolbar text>
          <v-icon>business</v-icon>
          <v-toolbar-title
            >Businesses ({{ items.length }} total)</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchQuery"
            v-on:keyup.enter="search(searchQuery)"
          ></v-text-field>
          <v-btn icon @click.stop="search(searchQuery)">
            <v-icon>search</v-icon>
          </v-btn>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="items"
          :must-sort="true"
          class="mt-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <a v-if="isAdmin" @click.stop="updateItem(props.item)">{{
                  props.item.name
                }}</a>
                <span v-else>{{ props.item.name }}</span>
              </td>
              <td>{{ props.item.created | moment("YYYY-MM-DD H:mm") }}</td>
              <td>
                <span class="grey--text">Code :</span>
                {{ props.item.code }}
                <br />
                <span class="grey--text">Twilio Phone :</span>
                {{ props.item.phone_number }}
                <br />
                <span class="grey--text">Front Channel :</span>
                {{ props.item.front_channel_id }}
                <br />
                <span class="grey--text">Default domain :</span>
                <span v-if="props.item.default_domain">{{
                  props.item.default_domain
                }}</span>
                <span v-else class="red--text font-weight-medium">None</span>
              </td>
              <td>
                <span class="grey--text">ID :</span>
                {{ props.item.contact_id }}
                <br />
                <span class="grey--text">Name :</span>
                {{ contactName(props.item) }}
                <br />
                <span class="grey--text">Email :</span>
                {{ contactEmail(props.item) }}
                <br />
                <span class="grey--text">Phone number :</span>
                {{ contactPhone(props.item) }}
              </td>
              <td>
                <a :href="subscriptionLink(props.item.code)" target="_new">{{
                  subscriptionLink(props.item.code)
                }}</a>
              </td>
              <td>
                <span
                  v-if="props.item.is_active"
                  class="green--text font-weight-medium"
                  >Active</span
                >
                <span v-else class="red--text font-weight-medium"
                  >Inactive</span
                >
              </td>
              <td>
                <v-btn icon @click.stop="updateItem(props.item)" v-if="isAdmin">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click.stop="removeItem(props.item.id)"
                  v-if="isAdmin"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>No data</template>
        </v-data-table>
        <v-footer class="pt-5"></v-footer>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<style>
.v-text-field input {
  font-size: 0.8em;
}
</style>
<script>
import fb from "@/firebase";
import { mapState, mapGetters, mapMutations } from "vuex";

import BusinessForm from "@/components/BusinessForm";

const businesses = fb.db.collection("business_profiles");

export default {
  components: {},
  data: () => ({
    items: [],
    newItemName: "",
    currentBusiness: {},
    searchQuery: "",
    noData: false,
    contacts: [],
    contact: {},
    headers: [
      { text: "Name", value: "name" },
      { text: "Created", value: "created" },
      { text: "Infos", value: "infos", sortable: false },
      { text: "Contact", value: "contact", sortable: false },
      { text: "Subscription link", value: "link", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ],
    total: 0,
    subscriptionUrl: process.env.VUE_APP_ACCOUNT_SUBSCRIPTION_URL
  }),
  computed: {
    ...mapState({
      businessList: "businesses",
      defaultBusinessCode: "defaultBusinessCode"
    }),
    ...mapGetters(["isAdmin"])
  },
  firestore: {
    items: businesses
  },
  mounted: function() {
    this.contacts = [];
    businesses.get().then(snapshot => {
      snapshot.forEach(doc => {
        if (doc.data().contact_id) {
          fb.db
            .collection("user_profiles")
            .doc(doc.data().contact_id)
            .get()
            .then(user => {
              this.contacts.push({
                id: user.id,
                name: user.data().display_name,
                email: user.data().email,
                phone: user.data().phone_number
              });
            });
        }
      });
    });
  },
  methods: {
    ...mapMutations(["setAppAlert"]),
    createItem() {
      const voidBusiness = {
        phone_number: ""
      };
      this.$modal.show(
        BusinessForm,
        {
          business: voidBusiness
        },
        {
          height: "auto",
          scrollable: true
        }
      );
    },
    removeItem(id) {
      if (id) {
        if (confirm("Are you sure ?")) {
          businesses.doc(id).delete();
          let businessIndex = this.businessList.findIndex(function(element) {
            return element.id === id;
          });
          this.businessList.splice(businessIndex, 1);
          this.setAppAlert({
            visible: true,
            text: "The business has been removed",
            color: "success"
          });
        }
      }
    },
    updateItem(item) {
      this.currentItem = Object.assign({}, item);
      this.currentItem.id = item.id;
      this.$modal.show(
        BusinessForm,
        {
          business: this.currentItem
        },
        {
          height: "auto",
          scrollable: true
        }
      );
    },
    /*contactInfo: function(item) {
      if (item.contact_id) {
        let contact = this.contacts.find(function(element) {
          return element.id === item.contact_id;
        });
        return contact.name
      }
    },*/
    contactName(item) {
      if (item.contact_id) {
        let contact = this.contacts.find(element => {
          return element.id === item.contact_id;
        });
        if (contact !== undefined) {
          return contact.name;
        }
        return "";
      }
    },
    contactEmail(item) {
      if (item.contact_id) {
        let contact = this.contacts.find(element => {
          return element.id === item.contact_id;
        });
        if (contact !== undefined) {
          return contact.email;
        }
        return "";
      }
    },
    contactPhone(item) {
      if (item.contact_id) {
        let contact = this.contacts.find(element => {
          return element.id === item.contact_id;
        });
        if (contact !== undefined) {
          return contact.phone;
        }
        return "";
      }
    },
    search(query) {
      this.noData = false;
      let ref = fb.db.collection("business_profiles");
      let found = false;
      if (query && query.length >= 5) {
        if (query.indexOf("+") === 0) {
          ref = ref.where("phone_number", "==", query);
          found = true;
        } else if (/^\d+$/.test(query)) {
          ref = ref.where("phone_number_national", "==", query);
          found = true;
        } else if (query.length === 10) {
          ref = ref.where("code", "==", query);
          found = true;
        }
        if (found) {
          ref
            .get()
            .then(snapshot => {
              if (snapshot.empty) {
                this.noData = true;
              } else {
                snapshot.forEach(doc => {
                  this.itemFound = doc.data();
                  this.itemFound.id = doc.id;
                });
                this.items = [this.itemFound];
              }
            })
            .catch(() => {
              this.noData = true;
            });
        } else {
          ref = ref
            .doc(query)
            .get()
            .then(doc => {
              if (doc.data()) {
                this.itemFound = doc.data();
                this.itemFound.id = doc.id;
                this.items = [this.itemFound];
              } else {
                this.noData = true;
              }
            })
            .catch(() => {
              this.noData = true;
            });
        }
      } else {
        this.$bind(
          "items",
          fb.db.collection("business_profiles").orderBy("name")
        );
      }
    },
    subscriptionLink(code) {
      return code !== this.defaultBusinessCode
        ? `${this.subscriptionUrl}/${code}`
        : `${this.subscriptionUrl}`;
    }
  }
};
</script>
